<template>
    <div>
        <div class="row">
            <div id="sidebar-collapse" class="col-sm-4 col-lg-3 sidebar">
              
                <div class="col-sm-12">
                    <ul id="main-nav" class="main-nav nav nav-tabs nav-stacked" style="border-bottom: 0 ">

                        <!-- <li>
                            <a href="#" title="中国地图" style="background: #3C4049; color: #fff; text-align: center; font-size: 16px; font-weight: lighter">
                                <i class="glyphicon glyphicon-globe"></i> 中国地图
                            </a>
                        </li> -->

                        <li v-for="(item,index) in titleList" :key="index">
                            <a :href="'#target'+index" class="nav-header collapsed" data-toggle="collapse" :title="item.title">
                                <i class="glyphicon glyphicon-th-list"></i>
                                {{item.title}}
                                <span class="pull-right glyphicon glyphicon-chevron-toggle"></span>
                            </a>
                            <ul :id="'target'+index" class="secondmenu collapse list-group ">
                                <div class="js-blog-list2">
                                    <li class="list-group-item" v-for="(item,index) in item.children" :key="index">
                                       <router-link :to="item.url" :title="item.title">
                                            <span class="glyphicon glyphicon-map-marker"></span>
                                            {{item.title}}
                                       </router-link>
                                        <!-- <a href="/map/m04db" :title="item">
                                        <span class="glyphicon glyphicon-map-marker"></span>
                                       {{item}}</a> -->
                                    </li>
                                </div>
                            </ul>
                        </li>
                     
                    </ul>
                </div>
           
                <div style="clear: both"></div>
            </div>

            <div class="col-sm-8 col-lg-9  main">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="col-sm-12">
                            <div style="padding: 0px 10px 10px 10px;">
                                <a :href="linkSrc" target="_blank" :title="title" >
                                <img :src="imgSrc" :alt="title" class="img-responsive" style="border: 1px solid grey;">
                                </a>
                            </div>
                           <section class="app-main">
                                <transition name="fade-transform" mode="out-in">
                                <!-- <keep-alive > -->
                                    <router-view />
                                <!-- </keep-alive> -->
                                </transition>
                            </section>
                        </div>
                        <!-- <div class="col-sm-3">
                                <div class="panel panel-black">
                                    <div class="panel-heading">我要报错</div>
                                    <div class="panel-body" style="font-size: x-small">
                                        <form>
                                        <div class="form-group">

                                        </div>
                                        </form>
                                    </div>
                                </div>
                        </div> -->
                    </div>
                </div>
            </div>
         
        </div>
        <div class="floorNav" style="">
             
            <a href="http://www.mohurd.gov.cn/" target="_blank">本地图数据均来自于住建部官网</a>
            <span> | </span>
            <a href="https://beian.miit.gov.cn/">闽ICP备12011984号-5</a>
    	</div>
    </div>
</template>

<script>
    export default{
        data() {
            return {
                titleList:[
                    {
                        // title: "中国行政地图",
                        title: "矽创水资源数据系统",
                        
                        children:[
                        {'title':"2018年城市漏损率地图",url:'/mapleakrate'},
                        {'title':"2018年城市人均日用水量地图",url:'/mapuse'},
                        {'title':"2018年城市节约用水量地图",url:'/mapsave'},
                        {'title':"2018年城市供水总量地图",url:'/mapwatertotal'},
                        {'title':"2018年城市供水管道密度地图",url:'/mappipedensity'},
                        {'title':"2018年城市供水管道长度地图",url:'/mappipelength'},
                        {'title':"2018年城市公共供水普及率地图",url:'/mapwaterrate'},
                      
                      
                        ]
                    }
                ],
                 title:"厦门矽创官网",
                imgSrc:require('../../static/images/guanwang.jpg'),
                linkSrc:'https://www.silicomtech.cn',
                ad:[
                    {
                          title:"厦门矽创官网",
                          imgSrc:require('../../static/images/guanwang.jpg'),
                          linkSrc:'https://www.silicomtech.cn',
                    },
                    {
                          title:"厦门矽创探漏产品",
                          imgSrc:require('../../static/images/gongz.jpg'),
                          linkSrc:'https://www.silicomtech.cn/Content/544006.html',
                    },
                    {
                          title:"厦门矽创探漏公众号",
                          imgSrc:require('../../static/images/gongz.jpg'),
                          linkSrc:'https://www.silicomtech.cn/Content/544006.html',
                    },
                ]
              
              
            };
        },
        methods:{

        },
        mounted(){
            document.title="矽创水资源数据系统";
            $("ul:first-child a:first").click();
        },
        computed: {
            key() {
            return this.$route.path
            }
        }

    }
</script>

<style scoped>
.row{
    margin-left: 0px;
    margin-right: 0px;
}
.panel-black {
    border-color: #666;
}
.panel-black .panel-heading {
    color: #fff;
    background-color: #666;
    border-color: #666;
}
.main-nav{
    text-align: left;
}
/* .nav-stacked>li {
    float: none;
}
.nav>li {
    position: relative;
    display: block;
} */
.nav-header{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.nav-tabs{

}
@import './map_styles.css';

</style>